export const initialise = () => {
    const page: HTMLBodyElement | null = document.querySelector('.job-results')
    if (!page) return
    addLocationRadiusSearchLabel(page)
    restructureLocationRadiusSlider(page)
    jobFiltersClickHandler(page)
    moveKeywordSearch(page)
    addClearFiltersButton(page)
    locationFilter(page)
}

const addLocationRadiusSearchLabel = (page: HTMLBodyElement) => {
    const container: HTMLElement | null = page.querySelector('.location-filter .location-search')
    if (!container) return

    const label: HTMLLabelElement = document.createElement('label')
    label.classList.add('location-search-header')
    label.textContent = '{{js.job-results-location-search-filter-label}}'

    container.prepend(label)
}

const restructureLocationRadiusSlider = (page: HTMLBodyElement) => {
    const wrapper: HTMLElement | null = page.querySelector('.location-filter .location-slider-wrapper')
    if (!wrapper) return
    
    const container = document.createElement('div')
    container.classList.add('location-slider-container')

    const label: HTMLLabelElement = document.createElement('label')
    label.classList.add('location-slider-header')
    label.textContent = '{{js.job-results-location-slider-filter-label}}'
    container.prepend(label)

    const content = page.querySelector<HTMLDivElement>('.location-filter .location-radius-text')
    if (content) container.appendChild(content)

    const slider = page.querySelector<HTMLDivElement>('.location-filter .location-slider')
    if (slider) container.appendChild(slider)

    wrapper.appendChild(container)
}

const jobFiltersClickHandler = (page: HTMLBodyElement) => {
    const filters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.optionfiltergroup')

    filters.forEach((filter: HTMLDivElement) => {
        const filterHeader = filter.querySelector<HTMLHeadingElement>('.option-type-header')
        if (!filterHeader) return

        const filterList = filter.querySelector<HTMLUListElement>('.option-display-list')
        if (!filterList) return

        filterList.setAttribute('aria-hidden', 'true')
        filterHeader.setAttribute('aria-expanded', 'false')

        filterHeader.addEventListener('click', function(event: Event) {
            const target: HTMLHeadingElement = event.target as HTMLHeadingElement
            const expanded = target.getAttribute('aria-expanded') === 'true'
            target.setAttribute('aria-expanded', String(!expanded))
            filterList.setAttribute('aria-hidden', String(!expanded))
            
            document.addEventListener('click', function clickAway(event: Event) {
                const target: HTMLElement = event.target as HTMLElement
                if (!filter.contains(target)) {
                    filter.classList.remove('category-opened')
                    filterHeader.setAttribute('aria-expanded', 'false')
                    filterList.setAttribute('aria-hidden', 'true')
                    document.removeEventListener('click', clickAway)
                }
            })

            document.addEventListener('keyup', function keyboardAway(event: KeyboardEvent) {
                if (event.key === 'Escape' || !filter.contains(document.activeElement)) {
                    filter.classList.remove('category-opened')
                    filterHeader.setAttribute('aria-expanded', 'false')
                    filterList.setAttribute('aria-hidden', 'true')
                    document.removeEventListener('keyup', keyboardAway)
                }
            })
            
            const openedFilters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.category-opened')
            if (filter.classList.contains('category-opened')) {
                filterHeader.setAttribute('aria-expanded', 'false')
                filterList.setAttribute('aria-hidden', 'true')
                filter.classList.remove('category-opened')

            } else {
                openedFilters.forEach((filter: HTMLDivElement) => {
                    filter.querySelector('.option-type-header')?.setAttribute('aria-expanded', 'false')
                    filter.querySelector('.option-display-list')?.setAttribute('aria-hidden', 'true')
                    filter.classList.remove('category-opened')
                })
                filter.classList.toggle('category-opened')
                filterHeader.setAttribute('aria-expanded', 'true')
                filterList.setAttribute('aria-hidden', 'false')
            }
        })
    })
}

const moveKeywordSearch = (page: HTMLBodyElement) => {
    const keywordSearch: HTMLDivElement | null = page.querySelector('#keyword-option-wrapper')
    if (!keywordSearch) return

    const container = page.querySelector<HTMLDivElement>('.job-results__hero-inner .container-col')
    if (!container) return

    container.append(keywordSearch)
}

const addClearFiltersButton = (page: HTMLBodyElement) => {
    const filters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.search-filters-widget .optionfiltergroup .apply-filters-btn-container')
    filters.forEach((filter) => {
        const clearButton: HTMLAnchorElement = document.createElement('a')
        clearButton.className = 'attrax-button filters-clear'
        clearButton.href = '{{js.job-results.filters.button.clear.href}}'
        clearButton.textContent = '{{js.job-results.filters.button.clear.text}}'
        clearButton.ariaLabel = '{{js.job-results.filters.button.clear.aria-label}}'

        filter.append(clearButton)
    })
}

const locationFilter = (page: HTMLBodyElement) => {
    const filter = page.querySelector<HTMLDivElement>('.location-filter')
    if (!filter) return

    const header = filter.querySelector<HTMLButtonElement>('.header')
    if (!header) return
    const button: HTMLButtonElement = document.createElement('button')
    button.classList.add('header')
    button.setAttribute('aria-expanded', 'false')
    button.setAttribute('aria-controls', 'location-slider-wrapper')
    button.textContent = header.textContent
    header?.replaceWith(button)

    button?.addEventListener('click', function(event: Event) {
        const target = event.target as HTMLButtonElement
        const expanded = target.getAttribute('aria-expanded') === 'true'
        target.setAttribute('aria-expanded', String(!expanded))

        document.addEventListener('click', function clickAway(event: Event) {
            const target: HTMLElement = event.target as HTMLElement
            if (!filter.contains(target)) {
                button.setAttribute('aria-expanded', 'false')
                document.removeEventListener('click', clickAway)
            }
        })

        document.addEventListener('keyup', function keyboardAway(event: KeyboardEvent) {
            if (event.key === 'Escape' || !filter.contains(document.activeElement)) {
                button.setAttribute('aria-expanded', 'false')
                document.removeEventListener('keyup', keyboardAway)
            }
        })
    })
}